module.exports = __webpack_public_path__ + "client/img/s_item_11.e6821598.png";